import { render, staticRenderFns } from "./vehicle.vue?vue&type=template&id=5d97b235&scoped=true&"
import script from "./vehicle.vue?vue&type=script&lang=js&"
export * from "./vehicle.vue?vue&type=script&lang=js&"
import style0 from "./vehicle.vue?vue&type=style&index=0&id=5d97b235&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d97b235",
  null
  
)

export default component.exports